import Controller from '@ember/controller';

export default class AuthenticatedOrphanedController extends Controller {}
